import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2371c3f9&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2371c3f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371c3f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2371c3f9')) {
      api.createRecord('2371c3f9', component.options)
    } else {
      api.reload('2371c3f9', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2371c3f9&scoped=true&", function () {
      api.rerender('2371c3f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/components/detail.vue"
export default component.exports